import { render, staticRenderFns } from "./AccountPropertyTargetingsData.vue?vue&type=template&id=57afeda2"
import script from "./AccountPropertyTargetingsData.vue?vue&type=script&lang=js"
export * from "./AccountPropertyTargetingsData.vue?vue&type=script&lang=js"
import style0 from "./AccountPropertyTargetingsData.vue?vue&type=style&index=0&id=57afeda2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports